module.exports = __webpack_public_path__ + "img/Icon_Twitter.c028c882.svg";